// @ts-nocheck
// eslint-disable-next-line camelcase
import { unstable_createMuiStrictModeTheme } from '@material-ui/core/styles';

export default unstable_createMuiStrictModeTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#d21f1d',
    },
    secondary: {
      main: '#d21f1d',
    },
    background: {
      default: '#eee',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.54)',
    },
    overlay: '#f9f9f9',
    divider: '#e0e0e0',
  },
  overrides: {
    MuiBreadcrumbs: {
      root: {
        backgroundColor: '#fff',
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
      },
    },
    MuiTextField: {
      root: {
        '& label.Mui-focused': {
          color: 'rgba(0, 0, 0, 0.54)',
        },
        '& label.Mui-error': {
          color: '#f44336',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&.Mui-focused $notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.54)',
        },
        '&.Mui-error $notchedOutline': {
          borderColor: '#f44336',
        },
        '&:hover $notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.54)',
        },
        '& $notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.32)',
        },
      },
    },
  },
});
